import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Error from './Pages/Error/Error';
import HomeOne from "./Pages/HomeOne/HomeOne/HomeOne";
import ScrollTop from "./Pages/ScrollTop/ScrollTop";
import TournamentsPage from './Pages/TournamentsPage/TournamentsPage';
import ProRatingPage from './Pages/ProratingPage/ProRating';
import Slide from './Pages/Slide/Slide';
import NewsPage from './Pages/NewsPage/NewsPage';
import OrgRatingPage from './Pages/OrgRatingPage/OrgRatingPage';
import AmateurRatingPage from './Pages/AmateurRatingPage/AmateurRatingPage';
import FemalePage from './Pages/FemaleRatingPage/FemaleRatingPage';
import ScamPage from './Pages/ScamPage/ScamPage';
import MediaPage from './Pages/MediaPage/MediaPage';

function App() {
    return (
        <>
            <Slide />
            <Router><Routes>
                <Route path="/" element={<HomeOne />} />

                <Route path="/tournaments" element={<TournamentsPage />} />
                <Route path="/prorating" element={<ProRatingPage />} />
                <Route path="/orgrating" element={<OrgRatingPage />} />
                <Route path="/amateur" element={<AmateurRatingPage />} />
                <Route path="/female" element={<FemalePage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/scam" element={<ScamPage />} />
                <Route path="/media" element={<MediaPage />} />
                <Route path="*" element={<Error />} />
            </Routes></Router>
            <ScrollTop />
        </>
    )
}

export default App;
